import ImageClass, { asImages } from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { chris } from "../characters/Chris";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { v1AfterDates } from "./V1";

const images = asImages({
    BarVanessaFar: { url: require("@lss/common/game/assets/images/V1/BarVanessaFar.webp") },
    BarVanessa2: { url: require("@lss/common/game/assets/images/V1/BarVanessa2.webp") },
    BarVanessa2_talking: { url: require("@lss/common/game/assets/images/V1/BarVanessa2_talking.webp") },
    BarVanessa2_natural: { url: require("@lss/common/game/assets/images/V1/BarVanessa2_natural.webp") },
    BarVanessaBartender: { url: require("@lss/common/game/assets/images/V1/BarVanessaBartender.webp") },
    BarVanessaBartender2: { url: require("@lss/common/game/assets/images/V1/BarVanessaBartender2.webp") },
    BarVanessaBartender3: { url: require("@lss/common/game/assets/images/V1/BarVanessaBartender3.webp") },
    BarVanessa3: { url: require("@lss/common/game/assets/images/V1/BarVanessa3.webp") },
    BarVanessa5: { url: require("@lss/common/game/assets/images/V1/BarVanessa5.webp") },
    BarVanessa1: { url: require("@lss/common/game/assets/images/V1/BarVanessa1.webp") },
    BarVanessa4: { url: require("@lss/common/game/assets/images/V1/BarVanessa4.webp") },
    BarStreetBehind: { url: require("@lss/common/game/assets/images/V1/BarStreetBehind.webp") },
    BarVanessaChrisFar: { url: require("@lss/common/game/assets/images/V1/BarVanessaChrisFar.webp") },
});



export const v1VanessaBarMeeting = async () => {
    ImageClass.setImage(images.BarVanessaFar, { duration: 0.6 });

    if (mc.properties.metVanessa) {

        mc.think(`There is Vanessa, sitting alone.\nJoey wasn't kidding about the bar being empty.`);
    } else {
        mc.think(`The bar is empty except that one girl sitting there, I recognize her from the photos, that's Vanessa.`);
        if(mc.properties.v1MCSawVanessasBoobsAss){
            mc.think(`She has on more clothes than I remember but that's fine. Haha.`);
        
        }

    }
    mc.think(`I better go and say hi.`);

    ImageClass.setImage(images.BarVanessa2);
    mc.talk(`Hey Vanessa!`);
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`Hey ${mc.name}! I'm so glad you could make it.`);
    vanessa.talk(`I know it seems kinda weird, like why would Joe's girlfriend call you and ask you to come here with her, right?`);
    ImageClass.setImage(images.BarVanessa2_natural);
    mc.talk(`Yeah... I can't say it isn't, especially since I don't know you at all.`);
    if (mc.properties.metVanessa) {

        mc.talk(`I mean, we met once at my place with Joey, but we didn't really talk. Since it was a short visit.`);
    }
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`That's exactly why I wanted to meet with you.`);
    vanessa.talk(`You are Joe's best friend that's why I wanted to get close to you and learn more about you.\nBesides the things I already know.`);
    ImageClass.setImage(images.BarVanessa2_natural);
    mc.talk(`What do you know?`);
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`That you are kind of a loner. That you like video games and that you're a very good friend... That's the main stuff.`);
    ImageClass.setImage(images.BarVanessa2_natural);
    mc.talk(`That's not a lie...\nThat's basically it, there isn't much more to tell to be honest.`);
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`I'm sure there is. But you barely know me, so I can understand you not wanting to tell your life story to a total stranger.`);
    vanessa.talk(`But there is another thing that I am sure you can help me with.`);


    ImageClass.setImage(images.BarVanessa2);
    mc.talk(`What's that?`);
    await vanessa.setQuestion(new Question({ text: `Joe's birthday is coming up and I don't know what should I get for him.\nDo you have any ideas for me?`, key: `v1JoePresentIdea` })
        .option({ title: `A video game`, key: 'videogame' })
        .option({ title: `Make a sex tape`, key: 'sextape' })
        .option({ title: `I don't know...`, key: 'dunno' }));
    if (Question.globalAnswers.v1JoePresentIdea === "videogame") {
        mc.talk(`There is a video game that I know he wanted to play, maybe you should get him that.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`A video game?? Booooringggg.`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`Maybe for you, I'm sure he would love it.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`Not the Joe I know.`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`You did say that I am his best friend, so shouldn't I know better?`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`Yes, but you haven't seen him for a year, he is not like that anymore.`);
        ImageClass.setImage(images.BarVanessa2_natural);
        vanessa.talk(`Anyway, thanks for you help, I'll think of something myself.`);
    }
    if (Question.globalAnswers.v1JoePresentIdea === "sextape") {
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`There is this thing I know he could love... But I don't know how to say it...`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`Just say it.`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`I know he loves watching porn, so if you would make some kind of a sex tape with him I bet he would love to watch that instead.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`OH MY GOD!`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`Sorry that wasn't appropriate.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`NO! That's a great idea! That would be the perfect present!`);
        vanessa.talk(`I knew I could count on you!`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`Well... Thanks... I guess.`);
    } else {
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`I really don't know, he had changed so much I think he wants different things than the ones I can think of.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`Come on there's gotta be something.`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`Nothing that crosses my mind sorry.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`I'll think of something myself...`);
        ImageClass.setImage(images.BarVanessa2_natural);
        mc.talk(`Good luck.`);
    }


    ImageClass.setImage(images.BarVanessaBartender);
    chris.talk(`Good evening and thanks for coming, I'm Chris and I'll be your waiter this evening.`);

    vanessa.talk(`Really? Waiter? You?`);
    chris.talk(`Yes, is there something wrong?`);
    vanessa.talk(`You seem more like a bartender than a waiter.`);
    chris.talk(`I usually work as a bartender, but when there are only a few customers I do both.`);
    vanessa.talk(`Oh, ok. Haha.`);
    chris.talk(`So, what can I get for you?`);
    ImageClass.setImage(images.BarVanessaBartender2);
    mc.talk(`Beer for me.`);
    ImageClass.setImage(images.BarVanessaBartender);
    await chris.setQuestion(new Question({ text: 'And for your lovely girlfriend?', key: `v1ChrisCalledVanessaGF` })
        .option({ title: `She is not my girlfriend`, key: 'sheIsNot' })
        .option({ title: `Say nothing`, key: 'sayNothing' }));
    if (Question.globalAnswers.v1ChrisCalledVanessaGF === "sheIsNot") {
        mc.talk(`She is not my girlfriend.`);
        vanessa.talk(`I would like to have some white wine please.`);
    } else {

        vanessa.talk(`I would like to get some white wine please.`);
    }
    chris.talk(`Coming right out.`);

    ImageClass.setImage(images.BarVanessa2);
    if (Question.globalAnswers.v1ChrisCalledVanessaGF === "sayNothing") {
        ImageClass.setImage(images.BarVanessa2);
        mc.talk(`You didn't correct him for thinking you are my girlfriend.`);
        ImageClass.setImage(images.BarVanessa2_talking);
        vanessa.talk(`Does it matter? I don't know him.`);
        ImageClass.setImage(images.BarVanessa2);
        mc.talk(`I guess that's true.`);
        mc.think(`I don't know if it's just me but I have a weird feeling about both of them.\nMaybe I should say something to Joey?`);
        mc.think(`But then again, it could be just my imagination.`);
    }


    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`I thought you would order water or soda.`);
    ImageClass.setImage(images.BarVanessa2);
    mc.talk(`What? Of course not.`);
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`So you do have some potential in you.`);
    ImageClass.setImage(images.BarVanessa2);
    mc.talk(`Potential for what?`);
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`To be a man of many ladies.`);
    mc.talk(`Just because I drink beer?`);
    ImageClass.setImage(images.BarVanessa2_talking);
    vanessa.talk(`It starts with that.`);

    // bartender with drinks
    ImageClass.setImage(images.BarVanessaBartender3);
    chris.talk(`Here are your drinks.`);
    vanessa.talk(`Wow that was fast!`);
    chris.talk(`No other customers as you can see, so at least I could get you yours fast.`);
    vanessa.talk(`Makes sense haha!`);
    vanessa.talk(`It must be boring being here all alone.`);
    mc.think(`Is she flirting with him?`);
    chris.talk(`It can be, but I'm not alone right now.`);
    vanessa.talk(`Haha.`);
    chris.talk(`Enjoy the rest of the evening. I'll be at the bar, if you need anything just raise your hand and I'll be right here!`);
    vanessa.talk(`I'll be sure to remember that!`);
    ImageClass.setImage(images.BarVanessa5);
    vanessa.talk(`O-M-G, isn't he a real cutie??`);
    mc.talk(`...`);
    vanessa.talk(`WHAT?`);
    vanessa.talk(`I didn't do anything! I was just thinking out loud.\nForget about it.`);

    ImageClass.setImage(images.BarVanessa3);
    mc.think(`She is definitely into him...`);
    mc.think(`To be honest she is right, she didn't do anything, she was just sharing her thoughts...\nMaybe it's better to keep my mouth shut.`);
    mc.think(`When the time comes we'll see what I decide to do.`);



    vanessa.talk(`Ok, so where were we?`);
    ImageClass.setImage(images.BarVanessa1);
    vanessa.talk(`Oh right!\nI wanted to ask you.`);
    ImageClass.setImage(images.BarVanessa3);
    vanessa.talk(`How is it going with Ann?`);
    ImageClass.setImage(images.BarVanessa4);
    mc.talk(`Hmmm... Well I was supposed to be here with her right now... But...`);
    ImageClass.setImage(images.BarVanessa3);
    vanessa.talk(`I can't believe you convinced her to come here with you, I've been trying to get her to go out with me for ages, but she always makes up stupid excuses.`);
    ImageClass.setImage(images.BarVanessa4);
    mc.talk(`I hope she will agree to meet with me again after I bailed on her tonight...`);
    ImageClass.setImage(images.BarVanessa3);
    vanessa.talk(`She will, it's not like she has anything else to do besides reading stupid books.`);
    mc.talk(`We'll see, I hope you are right.`);
    ImageClass.setImage(images.BarVanessa4);
    return jump(v1VanessaDateQuestions, "v1VanessaDateQuestions");
};

export const v1VanessaDateQuestions = async (): Promise<any> => {

    await mc.setQuestion(new Question({ text: 'There are some things I wanted to talk about.', key: `v1VanessaDateConv`, options: { array: "v1VanessaDateConvArr" } })
        .option({ title: `How do you know Ann`, key: 'howKnowAnn', hide: Question.globalAnswers.v1VanessaDateConvArr?.includes("howKnowAnn") })
        .option({ title: `How did you and Joey meet`, key: 'howMeetWithJoe', hide: Question.globalAnswers.v1VanessaDateConvArr?.includes("howMeetWithJoe") })
        .option({ title: `It's getting late`, key: 'finish' }));
    if (Question.globalAnswers.v1VanessaDateConv === "howKnowAnn") {
        ImageClass.setImage(images.BarVanessa4);
        mc.talk(`How do you know Ann?`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`Our parents are friends and they used to meet up when we were kids, so we became good friends.`);
        ImageClass.setImage(images.BarVanessa1);
        vanessa.talk(`Even though we grew up together we are really different as you can tell.`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`I am the more outgoing type and she is the more closed and shy type.`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`She is still a very good friend of mine, I just wish she would open up more some day.`);

    } else if (Question.globalAnswers.v1VanessaDateConv === "howMeetWithJoe") {
        ImageClass.setImage(images.BarVanessa4);
        mc.talk(`How did you and Joey meet?`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`It's still funny to me hearing you call him Joey.`);
        ImageClass.setImage(images.BarVanessa4);
        mc.talk(`I know, I am still trying to get used to the new JOE.`);
        ImageClass.setImage(images.BarVanessa1);
        vanessa.talk(`Haha, you will eventually.`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`Ok, so back to the point.\nI was at the beach, tanning alone. He approached me and used his silver tongue.`);
        ImageClass.setImage(images.BarVanessa4);
        vanessa.talk(`We talked and laughed for a couple of hours then he asked for my number. I gave it to him, and of course he didn't call me the next day.`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`That's like the oldest trick in the book... Don't call a girl the next day so you won't seem desperate but whatever...`);
        ImageClass.setImage(images.BarVanessa1);
        vanessa.talk(`Anyways, he called me after a few days, we talked and got together, that's about it.`);
        ImageClass.setImage(images.BarVanessa4);
        mc.talk(`It's less spicy than I thought it would be.\nBut it seems like it worked.`);

        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`What did you expect?\nThis is real life, not an adult video game. Of course it went down that way.`);

        ImageClass.setImage(images.BarVanessa1);
        vanessa.talk(`And he is lucky he is good looking. Otherwise, it wouldn't have worked! Hehe.`);
    } else {

        ImageClass.setImage(images.BarVanessa4);
        mc.talk(`It's getting late I think we should get going.`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`You can leave. I'll finish my drink and head out.`);
        ImageClass.setImage(images.BarVanessa1);
        vanessa.talk(`Hey and ${mc.name} please don't say anything to Joe about our little meeting here alright?`);
        ImageClass.setImage(images.BarVanessa4);
        mc.talk(`I won't say a thing.`);
        mc.talk(`Good night Vanessa.`);
        ImageClass.setImage(images.BarVanessa3);
        vanessa.talk(`Good night!`);
        return jump(v1VanessaDateQuestionsFinish, "v1VanessaDateQuestionsFinish");
    }
    return v1VanessaDateQuestions();

};

export const v1VanessaDateQuestionsFinish = async () => {

    ImageClass.setImage(images.BarStreetBehind);

    mc.think(`So there I was, about to leave the bar after meeting with Vanessa.`);
    mc.think(`I took a few steps away from the bar, but something didn't feel quite right. I didn't understand why Vanessa would stay there, alone.`);
    mc.think(`I was way too curious to leave just like that so I turned around, just to ease my mind.`);
    ImageClass.setImage(images.BarVanessaChrisFar);

    mc.think(`There she was, sitting with Chris, the bartender.`);
    mc.think(`She seemed like she was into him... But what about Joey?`);
    mc.think(`She invited me to find a good present for his birthday, so it doesn't makes sense for her to flirt with someone else in front of me.`);
    mc.think(`Even though it's not about me, I couldn't help but think it's some kind of a test to see how I would act or what I would say.`);
    mc.think(`Vanessa must have known I would tell Joey if I saw something inappropriate...\nI better not jump to conclusions, but it does seem kinda fishy.`);

    // return v1VanessaBarMeeting()
    return jump(v1AfterDates, "v1AfterDates");
};




